import React from 'react';
import {
    Tab, Nav, Col, NavItem, Row, Table, Modal, Tooltip, OverlayTrigger
} from 'react-bootstrap';
import decode from 'jwt-decode';
import SweetAlert from "react-bootstrap-sweetalert";
import _ from 'lodash';
import Button from '../../../elements/CustomButton/CustomButton.jsx';
import ModalCargaFactura from '../../Components/ModalCargaFactura.jsx';
import { API_ROOT } from '../../../variables/api-config';
import ModalBlockWrapper from '../../Components/ModalBlockWrapper';

class AdministracionTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentUser: decode(localStorage.getItem('id_token')),
      selected: [],
      showDetail: {},
      checkBox: [],
      showModalSolicitud: false,
      showModalCarga: false,
      currentFactura: null,
    };
    this.generateFacturas = this.generateFacturas.bind(this);
    this.clickCheckBox = this.clickCheckBox.bind(this);
    this.onClickDetail = this.onClickDetail.bind(this);
    this.generateRendiciones = this.generateRendiciones.bind(this);
    this.onClickRendir = this.onClickRendir.bind(this);
    this.confirmRendir = this.confirmRendir.bind(this);
    this.editFactura = this.editFactura.bind(this);
  }

  componentWillMount() {
    if (this.props.compras && this.props.ventas) {
      const auxCheckBox = [];
      this.props.ventas.concat(this.props.compras).forEach(() => {
        auxCheckBox.push(false); // inicializar checkbox en false (controlled component)
      });
      this.setState({checkBox: auxCheckBox});
    }
  }

  editFactura(id, callback) {
    this.props.incubationService
      .getFacturaById(id)
      .then(res => {
        this.setState({currentFactura: res.factura});
        callback();
      })
      .catch(err => {
        this.props.setError(
          <div>
            Ha ocurrido un error mientras se cargaba la factura, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  generateFacturas(arrayFacturas, general) {
    let tooltip = <Tooltip id="tooltip"></Tooltip>;
    const facturas = arrayFacturas.sort((a, b) => {  // ordenar facturas por fecha
      a = new Date(a.fecha);
      b = new Date(b.fecha);
      return a < b ? -1 : a > b ? 1 : 0;
    });
    const html = [];
    facturas.forEach((item, index) => {
      let style = null;
      if (item.subtipo === 'VENTAS') {
        style = general && {backgroundColor: '#eaffe3'};
      }
      let disabledCheckbox = false;
      if (item.estado && item.estado === 'SOLICITADA') {
        disabledCheckbox = true;
        tooltip = (<Tooltip id="tooltip">Esta factura no ha sido aprobada!</Tooltip>);
      }
      if (parseInt(item.rendida, 10)) {
        disabledCheckbox = true;
        tooltip = (<Tooltip id="tooltip">Esta factura ya fue rendida!</Tooltip>);
      }
      let showModal;
      if (item.subtipo === 'COMPRA') {
        showModal = () => this.setState({showModalCarga: true});
      } else if (item.subtipo === 'VENTAS') {
        showModal = () => this.setState({showModalSolicitud: true});
      } else {
        showModal = () => console.log('This should not happen');
      }
      let labelTipo;
      switch (item.tipo) {
        case '001':
        labelTipo = 'A';
        break;
        case '006':
        labelTipo = 'B';
        break;
        case '011':
        labelTipo = 'C';
        break;
        default:
      }
      html.push(
        <tr key={index} style={style}>
          <td>{item.fecha}</td>
          <td>{labelTipo}</td>
          {(item.subtipo !== 'VENTAS' || general) &&
            <td>{item.numero}</td>
          }
          <td>{item.proveedor}</td>
          <td>{item.cuit}</td>
          <td>{item.concepto}</td>
          <td>{`$${item.neto}`}</td>
          <td>{`$${item.iva}`}</td>
          <td>{`$${item.ingresosbrutos}`}</td>
          <td>{`$${item.otrosconceptos}`}</td>
          <td>{`$${item.total}`}</td>
          {(item.subtipo === 'VENTAS' && !general) &&
            <td>{item.estado}</td>
          }
          <td className="text-right" style={{width: 0}}>
            {general ?
              <OverlayTrigger placement="right" trigger={!disabledCheckbox ? null : ['hover', 'focus']} overlay={tooltip}>
                <div className="checkbox">
                  <input
                    id={index} type="checkbox" onChange={(e) => this.clickCheckBox(item, e.target.checked, index)}
                    checked={this.state.checkBox[index]} disabled={disabledCheckbox}
                  />
                  <label htmlFor={index}></label>
                  <span className={''}></span>
                </div>
              </OverlayTrigger> :
              <div>
                <Button simple bsStyle="warning" bsSize="xs" onClick={() => this.editFactura(item.id, showModal)}>
                  <i className="fa fa-edit"></i>
                </Button>
                {item.path ?
                  <Button simple bsStyle="info" bsSize="xs">
                    <a href={`${API_ROOT}/incubation/factura/download/file?id=${item.id}`}>
                      <i className="fa fa-file"></i>
                    </a>
                  </Button> :
                  <Button simple bsStyle="default" bsSize="xs" disabled>
                    <i className="fa fa-file"></i>
                  </Button>
                }
              </div>
            }
          </td>
        </tr>
      );
    });
    return html;
  }

  generateRendiciones() {
    const html = [];
    this.props.rendiciones.forEach((item) => {
      html.push(
        <tr key={item.id}>
          <td className="text-center" style={{width: 150}}>{item.fecha}</td>
          <td className="text-center" style={{width: 200}}>{item.responsable}</td>
          <td className="text-center">
            <Button bsStyle="primary" bsSize="xs" fill wd
              onClick={this.state.showDetail[item.id] ? () => this.onClickDetail(item.id, false) : () => this.onClickDetail(item.id, true)}>
              {this.state.showDetail[item.id] ? 'Ocultar' : 'Ver Detalle'}
            </Button>
            {this.state.showDetail[item.id] &&
              <Table responsive>
                <thead>
                  <tr>
                    <th className="text-left">Concepto</th>
                    <th className="text-center"></th>
                    <th className="text-right">Posición Neta</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-left">IVA</td>
                    <td className="text-center" style={parseFloat(item.iva) < 0 ? {color: 'red'} : null}>{parseFloat(item.iva) < 0 ? 'A Pagar' : 'A Favor'}</td>
                    <td className="text-right" style={parseFloat(item.iva) < 0 ? {color: 'red'} : null}>{item.iva}</td>
                  </tr>
                  <tr>
                    <td className="text-left">Ingresos Brutos</td>
                    <td className="text-center" style={parseFloat(item.ingresosbrutos) < 0 ? {color: 'red'} : null}>{parseFloat(item.ingresosbrutos) < 0 ? 'A Pagar' : 'A Favor'}</td>
                    <td className="text-right" style={parseFloat(item.ingresosbrutos) < 0 ? {color: 'red'} : null}>{item.ingresosbrutos}</td>
                  </tr>
                  <tr>
                    <td className="text-left">Participacion UNCUYO</td>
                    <td className="text-center" style={{color: 'red'}}>A Pagar</td>
                    <td className="text-right" style={{color: 'red'}}>{item.participacion}</td>
                  </tr>
                  <tr>
                    <td className="text-left">Saldo Emprendor</td>
                    <td className="text-center">A Favor</td>
                    <td className="text-right">{item.saldo}</td>
                  </tr>
                </tbody>
              </Table>
            }
          </td>
        </tr>
      );
    });
    return html;
  }

  onClickDetail(id, value) {
    const auxState = this.state.showDetail;
    auxState[id] = value;
    this.setState({ showDetail: auxState });
  }

  clickCheckBox(item, checked, index) {
    let value = this.state.checkBox.slice();
    value[index] = checked;   // guardar en state valor del checkbox (controlled component)
    const auxState = this.state.selected;
    if (checked) {
      auxState.push(item);  // checked true entonces pusheo el id
    } else {
      const index = auxState.indexOf(item); // checked es false entonces busco la posicion del id que desmarcaron
      if (index > -1) {
        auxState.splice(index, 1);  // remuevo el id desmarcado
      }
    }
    this.setState({ selected: auxState, checkBox: value }); // asignacion final de facturas y checkbox
  }

  onClickRendir() {
    if (_.isEmpty(this.props.contrato)) {
      this.props.showAlert(
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Rendiciones"
          onConfirm={() =>this.props.hideAlert()}
          confirmBtnBsStyle="info"
          confirmBtnText="Aceptar"
          >
            En este momento no se puede realizar la rendición de las facturas debido a que no hay un contrato vigente en el proyecto.
          </SweetAlert>
        );
    } else {
      this.props.showAlert(
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Rendir Facturas"
          onConfirm={() => this.confirmRendir()}
          onCancel={() => this.props.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Sí!"
          cancelBtnText="Cancelar"
          showCancel
          >
            ¿Rendir las facturas seleccionadas?
          </SweetAlert>
        );
    }
  }

  confirmRendir() {
    const auxCheckBox = this.state.checkBox;
    this.state.checkBox.forEach((item, index) => {
      auxCheckBox[index] = false; // deseleccionar checkboxes
    });

    // separar facturas seleccionadas en base a tipo (compra o venta)
    const facturasCompra = [];
    const facturasVenta = [];
    this.state.selected.forEach((factura) => {
      if (factura.subtipo === 'COMPRA') {
        facturasCompra.push(factura);
      } else if (factura.subtipo === 'VENTAS') {
        facturasVenta.push(factura)
      }
    });
    // realizar calculos de la rendicion
    let ivaCompras = 0;
    let retencionesCompras = 0;
    facturasCompra.forEach((factura) => {
      ivaCompras += parseFloat(factura.iva);
      retencionesCompras += parseFloat(factura.ingresosbrutos);
    });
    let ivaVentas = 0;
    let totalNetoVentas = 0;
    let totalBrutoVentas = 0;
    let retencionesVentas = 0;
    facturasVenta.forEach((factura) => {
      ivaVentas += parseFloat(factura.iva);
      totalNetoVentas += parseFloat(factura.neto);
      totalBrutoVentas += parseFloat(factura.total);
      retencionesVentas += parseFloat(factura.ingresosbrutos);
    });

    let ivaFinal = ivaCompras - ivaVentas;
    let ingresosbrutosFinal = retencionesCompras - retencionesVentas;
    let participacion = -((parseFloat(this.props.contrato.ventas)/100)*(totalNetoVentas+ingresosbrutosFinal));

    // checkear si se aplica el canon mensual
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getYear();
    let applyCanon = true;
    this.props.rendiciones.forEach((rendicion) => {
      const rendicionDate = new Date(rendicion.fecha);  // checkear si se hizo alguna rendicion en el mes actual
      if (rendicionDate.getYear() === currentYear && rendicionDate.getMonth() === currentMonth) {
        applyCanon = false; // si existe entonces no hay que aplicar el canon mensual
      }
    });
    if (applyCanon) {
      participacion = participacion - parseFloat(this.props.contrato.canon);
    }

    let saldo = totalBrutoVentas + ivaFinal + ingresosbrutosFinal + participacion;

    // redondear a 2 decimales
    ivaFinal =+ ivaFinal.toFixed(2);
    ingresosbrutosFinal =+ ingresosbrutosFinal.toFixed(2);
    participacion =+ participacion.toFixed(2);
    saldo =+ saldo.toFixed(2);

    // armar objeto rendiciones

    const idsfacturas = [];
    this.state.selected.forEach((factura) => {
      idsfacturas.push(factura.id);
    });

    const rendicion = {
      fecha: new Date().toISOString().split('T')[0],
      responsable: this.state.currentUser.username,
      iva: ivaFinal,
      ingresosbrutos: ingresosbrutosFinal,
      participacion,
      saldo,
      idsfacturas,
      proyectoincubacionid: this.props.projectIncubationId,
    };

    this.props.rendirFacturas(rendicion);

    this.setState({ selected: [], checkBox: auxCheckBox });
    this.props.hideAlert();
  }

  render() {
    if (!this.props.contrato || !this.props.ventas || !this.props.compras || !this.props.rendiciones) {
      return (<div></div>);
    }
    return (
        <div >
          <Tab.Container id="registros-tabs" defaultActiveKey="Ventas">
            <Row className="clearfix">
              <Col sm={2}>
                <Nav bsStyle="pills" stacked>
                  <NavItem eventKey="Ventas">Ventas</NavItem>
                  <NavItem eventKey="Compras">Compras</NavItem>
                  <NavItem eventKey="Estado">Estado</NavItem>
                  <NavItem eventKey="Rendicion">Rendición</NavItem>
                </Nav>
              </Col>
              <Col sm={10} style={{border: 'solid 1px #59CAED', overflowY: 'auto'}}>
                <Tab.Content animation>
                  <Tab.Pane eventKey="Ventas">
                    <div style={{textAlign:'right', paddingBottom:'5px'}}>
                      <Button bsStyle="primary" bsSize="sm" fill wd onClick={() => this.setState({showModalSolicitud: true})}>
                        Solicitar Factura
                      </Button>
                    </div>
                    {this.props.ventas.length === 0 ?
                      <div>No hay facturas</div> :
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Fecha</th>
                            <th>Tipo</th>
                            <th>Cliente</th>
                            <th>Cuit</th>
                            <th>Concepto</th>
                            <th>Neto</th>
                            <th>IVA</th>
                            <th>IIBB</th>
                            <th>Otros</th>
                            <th>Total</th>
                            <th>Estado</th>
                            <th className="text-right">Acciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.generateFacturas(this.props.ventas)}
                        </tbody>
                      </Table>
                    }
                  </Tab.Pane>
                  <Tab.Pane eventKey="Compras">
                    <div style={{textAlign:'right', paddingBottom:'5px'}}>
                      <Button bsStyle="primary" bsSize="sm" fill wd onClick={() => this.setState({ showModalCarga: true})}>
                        Cargar Factura
                      </Button>
                    </div>
                    {this.props.compras.length === 0 ?
                      <div>No hay facturas</div> :
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Fecha</th>
                            <th>Tipo</th>
                            <th>Número</th>
                            <th>Proveedor</th>
                            <th>Cuit</th>
                            <th>Concepto</th>
                            <th>Neto</th>
                            <th>IVA</th>
                            <th>Retención IIBB</th>
                            <th>Otros</th>
                            <th>Total</th>
                            <th className="text-right" style={{width: 0}}>Acciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.generateFacturas(this.props.compras)}
                        </tbody>
                      </Table>
                    }
                  </Tab.Pane>
                  <Tab.Pane eventKey="Estado">
                    <div style={{textAlign:'right', paddingBottom:'5px'}}>
                      <Button bsStyle="primary" bsSize="sm" fill wd onClick={this.onClickRendir} disabled={this.state.selected.length === 0}>
                        Rendir Seleccionadas
                      </Button>
                    </div>
                    {this.props.ventas.length === 0 && this.props.compras.length === 0 ?
                      <div>No hay facturas</div> :
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>Fecha</th>
                            <th>Tipo</th>
                            <th>Número</th>
                            <th>Proveedor/Cliente</th>
                            <th>Cuit</th>
                            <th>Concepto</th>
                            <th>Neto</th>
                            <th>IVA</th>
                            <th>IIBB</th>
                            <th>Otros</th>
                            <th>Total</th>
                            <th>Seleccionar</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.generateFacturas(this.props.ventas.concat(this.props.compras), true)}
                        </tbody>
                      </Table>
                    }
                  </Tab.Pane>
                  <Tab.Pane eventKey="Rendicion">
                    {!_.isEmpty(this.props.contrato) &&
                      <div>
                        <h6>Participacion UNCUYO</h6><br/>
                        <Table responsive>
                          <thead>
                            <tr>
                              <th className="text-center">% Ventas</th>
                              <th className="text-center">% Acciones</th>
                              <th className="text-center">Canon Fijo</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="text-center">{`${this.props.contrato.ventas}%`}</td>
                              <td className="text-center">{`${this.props.contrato.acciones}%`}</td>
                              <td className="text-center">{this.props.contrato.canon}</td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    }
                    <h6>Rendiciones</h6><br/>
                    {this.props.rendiciones.length === 0 ?
                      <div style={{textAlign: 'center'}}>No hay rendiciones</div> :
                      <Table responsive>
                        <thead>
                          <tr>
                            <th className="text-center">Fecha</th>
                            <th className="text-center">Responsable</th>
                            <th className="text-center">Detalle</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.generateRendiciones()}
                        </tbody>
                      </Table>
                    }
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
          <Modal show={this.state.showModalSolicitud} onHide={() => this.setState({showModalSolicitud: false, currentFactura: null})} bsSize="large">
            <ModalBlockWrapper
              content={
                <div>
                  <Modal.Header closeButton>
                    <Modal.Title>Solicitar Factura de Venta</Modal.Title>
                  </Modal.Header>
                  <ModalCargaFactura
                    cancel={() => this.setState({showModalSolicitud: false, currentFactura: null})}
                    save={(factura) => this.props.saveFactura(factura, () => this.setState({showModalSolicitud:false, currentFactura: null}))}
                    tipo="VENTAS" currentFactura={this.state.currentFactura} setError={this.props.setError}
                  />
                </div>
              }
            />
          </Modal>
          <Modal show={this.state.showModalCarga} onHide={() => this.setState({showModalCarga: false, currentFactura: null})} bsSize="large">
            <ModalBlockWrapper
              content={
                <div>
                  <Modal.Header closeButton>
                    <Modal.Title>Cargar Factura de Compra</Modal.Title>
                  </Modal.Header>
                  <ModalCargaFactura
                    cancel={() => this.setState({showModalCarga: false, currentFactura: null})}
                    save={(factura) => this.props.saveFactura(factura, () => this.setState({showModalCarga:false, currentFactura: null}))}
                    tipo="COMPRA" currentFactura={this.state.currentFactura} setError={this.props.setError}
                  />
                </div>
              }
            />
          </Modal>
        </div>
    );
  }
}

export default AdministracionTab;



// WEBPACK FOOTER //
// ./src/views/Incubation/IncubationPage/AdministracionTab.jsx